import { Box, Button, Divider, FormControl, MenuItem, Select, SelectChangeEvent, Stack, Typography } from "@mui/material";
import { Drawer } from "../../Drawer";
import { globalTheme } from "../../../styles";
import { ACTIVE_ORDERS_TABLE_TAB_KEY, AUTHENTICATED_EMPLOYEE_JWT, ORDERS_TABLE_TABS } from "../../../constants";
import { useEffect, useState } from "react";
import { useUpdateAction } from "../../../hooks";
import { AMAZON_WI_ACTION_BUTTON, moveOrderActionItems } from "./moveOrderActionItems";
import { Flags } from "../../Flags/Flags";
import { useAmazonWIrefresh } from "../../../hooks/useAmazonWIRefresh";

export const OrderActionDrawer = ({ data, OnClose, onOpen, onSuccessfulUpdate, onSuccessfulAmazonRefresh }) => {
  const currentOrdersTab = localStorage.getItem(ACTIVE_ORDERS_TABLE_TAB_KEY);
  const [actionUpdateRequest, setActionUpdateRequest] = useState({ requestAvailable: false, request: [] });
  const [actionRequest, setActionRequest] = useState<{
    actionType: string;
    idList: string[];
    changes: { fieldName: string; oldValue: string; newValue: string | number }[];
  }>({
    actionType: "",
    idList: [],
    changes: [{ fieldName: "", oldValue: "", newValue: "" }],
  });
  const [selectedFlagId, setSelectedFlagId] = useState<string | number>();

  const onOrdersDispatch = () => {
    setActionUpdateRequest({ requestAvailable: true, request: [actionRequest] });
  };

  const { successfullUpdatedAction, updateActionResponseData } = useUpdateAction({
    updateActionRequest: actionUpdateRequest.request,
    enabled: actionUpdateRequest.requestAvailable,
  });

  useEffect(() => {
    if (updateActionResponseData?.code === "UNAUTHORIZED") {
      localStorage.removeItem(AUTHENTICATED_EMPLOYEE_JWT);
      window.location.reload();
    }
  }, [updateActionResponseData]);

  useEffect(() => {
    if (updateActionResponseData) {
      onSuccessfulUpdate(updateActionResponseData);
      setActionUpdateRequest({ requestAvailable: false, request: [] });
    }
  }, [updateActionResponseData]);

  const handleOnClickPicked = () => {
    setActionRequest({
      actionType: "PICKED",
      idList: data.orderIds,
      changes: [
        { fieldName: "pickingStatus", oldValue: "", newValue: "Picked" },
        { fieldName: "issueStatus", oldValue: "", newValue: "NoIssue" },
      ],
    });
  };
  const handleOnClickAssigned = () => {
    //Todo KeyWord Should be added to following when it is ready from backend side until then the assigned button will be disabled
    // setActionRequest({
    //   actionType: "",
    //   idList: data.orderIds,
    //   changes: [{ fieldName: "", oldValue: "", newValue: "" }],
    // });
  };
  const handleOnClickIssue = () => {
    setActionRequest({
      actionType: "ISSUE",
      idList: data.orderIds,
      changes: [{ fieldName: "issueStatus", oldValue: "", newValue: "Issue" }],
    });
  };
  const handleOnClickOnHold = () => {
    setActionRequest({
      actionType: "ON_HOLD",
      idList: data.orderIds,
      changes: [{ fieldName: "issueStatus", oldValue: "", newValue: "OnHold" }],
    });
  };
  const handleOnClickCancelled = () => {
    setActionRequest({
      actionType: "CANCELLED",
      idList: data.orderIds,
      changes: [{ fieldName: "shippingStatus", oldValue: "", newValue: "Cancelled" }],
    });
  };
  const handleOnClickUnPicked = () => {
    setActionRequest({
      actionType: "UNPICKED",
      idList: data.orderIds,
      changes: [
        { fieldName: "pickingStatus", oldValue: "", newValue: "Unpicked" },
        { fieldName: "issueStatus", oldValue: "", newValue: "NoIssue" },
        { fieldName: "shippingStatus", oldValue: "", newValue: "Unshipped" },
      ],
    });
  };

  useEffect(() => {
    if (actionRequest.actionType && actionRequest.idList && actionRequest.changes) {
      onOrdersDispatch();
    }
  }, [actionRequest]);

  const actionMoveOrderItems = moveOrderActionItems({
    handleOnClickPicked,
    handleOnClickUnPicked,
    handleOnClickAssigned,
    handleOnClickIssue,
    handleOnClickOnHold,
    handleOnClickCancelled,
  });

  const filteredOrderItems = actionMoveOrderItems.filter((item) => {
    // if (item.value === "PICKED") {
    //   return currentOrdersTab === "UN_PICKED";
    // }
    return currentOrdersTab !== item.value;
  });

  const [flags, setFlags] = useState([]);
  useEffect(() => {
    const dynamicFlags = Flags();
    setFlags(dynamicFlags);
  }, [Flags, data]);

  const handleFlagChange = (event: SelectChangeEvent) => {
    const newSelectedFlagId = event.target.value;
    setSelectedFlagId(newSelectedFlagId);

    const newSelectedFlag = flags.find((flag) => flag.id === newSelectedFlagId);
    setActionRequest({
      actionType: "FLAG_TYPE",
      idList: data.orderIds,
      changes: [{ fieldName: "flagType", oldValue: "", newValue: newSelectedFlag.value }],
    });
  };
  const handleRefetchAmazon = () => {
    onSuccessfulAmazonRefresh(data);
  };

  const actionAmazonWIItems = AMAZON_WI_ACTION_BUTTON({ handleRefetchAmazon });

  const amazonWIrefetch = () => {
    if (currentOrdersTab === ORDERS_TABLE_TABS.ERROR.value) {
      return actionAmazonWIItems;
    }
  };

  return (
    <Drawer open={onOpen} onClose={OnClose}>
      <Stack spacing={2} margin={2}>
        <Typography
          variant="subtitle2"
          component="span"
          sx={{
            backgroundColor: globalTheme.background,
            color: globalTheme.primaryColor,
            p: 1,
            borderRadius: 2,
            width: "fit-content",
          }}
        >
          Actions
        </Typography>
        <Divider sx={{ marginTop: 2 }} orientation="horizontal" variant="middle" flexItem />

        <Stack direction="row" justifyContent="space-between" sx={{ p: 1, marginTop: 2 }}>
          {filteredOrderItems?.map((button, index) => (
            <Button
              size={button.size}
              variant={button.variant}
              key={index}
              onClick={button.onClick}
              sx={{
                color: button.color,
                borderColor: button.borderColor,
                width: "fit-content",
              }}
              disabled={button.disable}
              startIcon={
                button.startIcon && (
                  <Box
                    component="span"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      opacity: button.disable ? 0.5 : 1,
                    }}
                  >
                    {button.startIcon}
                  </Box>
                )
              }
              endIcon={button.endIcon}
            >
              {button.label}
            </Button>
          ))}
        </Stack>
      </Stack>
      <Divider />
      <Stack m={2}>
        <Box>
          <Typography
            variant="subtitle2"
            component="span"
            sx={{
              backgroundColor: globalTheme.background,
              color: globalTheme.primaryColor,
              p: 1,
              borderRadius: 2,
              width: "fit-content",
            }}
          >
            Order Flag
          </Typography>
        </Box>
        <Stack spacing={2} marginBottom={2} marginTop={3} marginLeft={1} direction="column">
          <FormControl variant="standard" sx={{ width: "200px" }}>
            <Select
              labelId="flag-select-label"
              id="flag-select"
              value={selectedFlagId}
              onChange={handleFlagChange}
              sx={{ width: "200px" }}
            >
              {flags?.map((flag) => (
                <MenuItem key={flag.id} value={flag.id}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    {flag.id !== 0 && flag.icon}
                    {flag.id === 0 ? (
                      <Typography
                        variant="subtitle2"
                        component="span"
                        sx={{
                          color: globalTheme.primaryColor,
                          p: 1,
                          borderRadius: 2,
                          width: "fit-content",
                        }}
                      >
                        {flag.text}
                      </Typography>
                    ) : (
                      <Typography variant="body2" component="span">
                        {flag.text}
                      </Typography>
                    )}
                  </Stack>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Divider />
        {data?.siteName === "Amazon WI" && currentOrdersTab === "ERROR" && (
          <Box mt={4}>
            <>
              <Typography
                variant="subtitle2"
                component="span"
                sx={{
                  backgroundColor: globalTheme.background,
                  color: globalTheme.primaryColor,
                  p: 1,
                  borderRadius: 2,
                  width: "fit-content",
                }}
              >
                Amazon Order Action:
              </Typography>
              <Stack mt={2} direction="row" justifyContent="space-between">
                {amazonWIrefetch()?.map((button, index) => (
                  <Button
                    key={index}
                    variant={button.variant}
                    sx={{
                      color: button.color,
                      borderColor: button.borderColor,
                      width: "fit-content",
                    }}
                    onClick={button.onClick}
                    disabled={button.disable}
                    startIcon={
                      button.startIcon && (
                        <Box
                          component="span"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            opacity: button.disable ? 0.5 : 1,
                          }}
                        >
                          {button.startIcon}
                        </Box>
                      )
                    }
                    endIcon={button.endIcon}
                  >
                    {button.label}
                  </Button>
                ))}
              </Stack>
            </>
          </Box>
        )}
      </Stack>
    </Drawer>
  );
};
